import { IUser } from "@/models";
import { GetterTree } from "vuex";
import { IAccountState } from "./state";

const getters: GetterTree<IAccountState, any> = {
    isAuthenticated: (state): boolean => !(!state.msalAccount),
    isRegistered: (state): boolean => state.msalAccount?.localAccountId === state.user?.userUniqueId,
    userEmail: (state): string => (state.msalAccount?.idTokenClaims as any).email,
    username: (state): string => (state.msalAccount?.idTokenClaims as any).name,
    user: (state): IUser | null => state.user,
    userId: (state): string => (state.msalAccount?.idTokenClaims as any).oid,
};

export { getters };
